module.exports = __webpack_public_path__ + "static/media/low_zole.639e8df6.svg";